import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronUp = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} data-testid="chevron-up" aria-hidden="true">
            <path
                id="arrow"
                d="M11.7002 9.79L19.0002 17L20.4102 15.6L11.7002 7L3.00016 15.6L4.41016 17L11.7002 9.79Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronUp
